/* eslint-disable no-script-url */

import React from 'react';
import { Dropdown, MenuItem, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { formatListValue } from '@/shared/components/FormattedListValue';
import HoverToggle from '@/shared/components/HoverToggle';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import ToastrService from '@/shared/services/ToastrService';
import classNames from 'classnames';
import authService from '@/shared/services/AuthService';

import { SpinnerIcon } from '@/shared/components/Icons';
import CompliancyStatusIcon from './CompliancyStatusIcon';
import messages from './comliancyMessages';

class CompliancyStatusToggle extends React.PureComponent {
  state = {
    loading: false,
  };

  onToggleInapplicable = (relation, complianceType) => {
    const { intl, onComplianceUpdated } = this.props;
    this.setState({ loading: true }, () => {
      api.base
        .put(`${config.appUrls.api}/api/compliance/ToggleInapplicable`, null, {
          params: { relationId: relation.id, complianceType },
        })
        .then(({ data }) => {
          ToastrService.success(intl.formatMessage(messages.ChangesSaved));
          const { type, status, info } = data;

          this.setState(
            state => ({
              loading: false,
              statusInfo: state.statusInfo ? { ...state.statusInfo, [type]: info || [] } : null,
            }),
            () => onComplianceUpdated(relation.id, type, status),
          );
        })
        .catch(error => {
          handleHttpError(intl)(error);
          this.setState({ loading: false });
        });
    });
  };

  loadStatusInfo = () => {
    const { statusInfoLoaded } = this.state;
    const { item, intl } = this.props;
    if (statusInfoLoaded) return;

    this.setState({ loadingStatusInfo: true }, () => {
      api.base
        .get(`${config.appUrls.api}/api/compliance/statusinfo?relationId=${item.id}`)
        .then(({ data }) => {
          this.setState({
            statusInfoLoaded: true,
            loadingStatusInfo: false,
            statusInfo: !data
              ? []
              : (data || []).reduce((o, i) => {
                  o[i.type] = [...(o[i.type] || []), i]; // eslint-disable-line no-param-reassign
                  return o;
                }, {}),
          });
        })
        .catch(error => {
          handleHttpError(intl)(error);
          this.setState({ loadingStatusInfo: false });
        });
    });
  };

  render() {
    const { id, item, compliancyStatus, compliancyType, onNavigateCompliance, intl } = this.props;
    const { loading, loadingStatusInfo, statusInfo } = this.state;
    const status = compliancyStatus;
    if (status === null) return '';
    if (loading) return <SpinnerIcon />;
    const canUpdate = authService.hasPermission({
      functionality: 'Relation',
      privilege: 'Update',
    });

    return (
      <Dropdown id={id} className="CompliancyStatusToggle" onMouseEnter={this.loadStatusInfo}>
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="left"
          rootClose
          overlay={
            <Tooltip id={`${item.id}-${compliancyType}`}>
              <div className="text-nowrap">
                <i
                  className={classNames('fa fa-fw', {
                    'fa-times red': status === 0,
                    'fa-warning orange': status === 1,
                    'fa-check': status === 2,
                    'fa-times-circle': status === 3,
                  })}
                />
                <span className="bold">
                  {formatListValue({ id: compliancyType, list: 'compliancetype', intl })}
                </span>
              </div>
              {status === 3 && (
                <div key={`${item.id}-${compliancyType}-10000`} className="text-left">
                  {formatListValue({
                    id: 10000,
                    list: 'complianceinformation',
                    values: {},
                    intl,
                  })}
                </div>
              )}
              {!loadingStatusInfo &&
                statusInfo &&
                status !== 3 &&
                statusInfo[compliancyType] &&
                statusInfo[compliancyType].length > 0 &&
                statusInfo[compliancyType].map((x, i) => (
                  <div key={`${item.id}-${compliancyType}-${x.info}-${i}`} className="text-left">
                    {formatListValue({
                      id: x.info,
                      list: 'complianceinformation',
                      values: x.parameters || {},
                      intl,
                    })}
                  </div>
                ))}
            </Tooltip>
          }
        >
          <a onClick={() => onNavigateCompliance(item, compliancyType, compliancyStatus)}>
            <CompliancyStatusIcon status={status} />
          </a>
        </OverlayTrigger>

        {canUpdate ? <HoverToggle bsRole="toggle" /> : null}
        <Dropdown.Menu className="unselectable">
          {status !== 3 && (
            <MenuItem eventKey="4" onSelect={() => this.onToggleInapplicable(item, compliancyType)}>
              <i className="fa fa-lg fa-times-circle text-grey margin5R" />
              <FormattedMessage {...messages.MarkAsInapplicable} />
            </MenuItem>
          )}
          {status === 3 && (
            <MenuItem eventKey="4" onSelect={() => this.onToggleInapplicable(item, compliancyType)}>
              <i className="fa fa-undo margin5R" />
              <FormattedMessage {...messages.MarkAsApplicable} />
            </MenuItem>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default injectIntl(CompliancyStatusToggle);
